// extracted by mini-css-extract-plugin
module.exports = {"title":"_20xnLMt8HSYIZt3APm_D-2","subtitle":"_3I0uu3G4FMRvPD30qUn3Nv"};